import axios from 'axios'

const getHeaders = (oidEmpresa) => {
  return {
    'x-phoenix-empresa': oidEmpresa,
  }
}

const commandAtendimento = ({
  oidEmpresa,
  nomeResponsavel,
  nomeFalecido,
  foneResponsavel,
  oidUnidade,
  oidAuxiliar,
}) => {
  const params = {
    command: 'atendimentoPublico',
    params: [
      { nomeResponsavel },
      { nomeFalecido },
      { foneResponsavel },
      { oidUnidade },
      { oidAuxiliar },
      { oidEmpresa },
    ],
  }

  //FIXME isso deve vir do BE
  // const host = 'http://18.211.149.146' // staging
  const host = 'https://srvc-nota-fiscal.lottustech.com.br' //   producao
  // const host = 'http://localhost'
  const path = `${host}/api/v1/heternum/admin/command/public`
  return axios.post(path, params, { headers: getHeaders(oidEmpresa) })
}

const commandIndicador = ({
  oidEmpresa,
  oidUnidade,
  nomeParceiro,
  cpfParceiro,
  foneParceiro,
  emailParceiro,
  tipoChavePix,
  chavePix,
}) => {
  const params = {
    command: 'cadastrarParceiro',
    params: [
      { oidEmpresa },
      { oidUnidade },
      { nomeParceiro },
      { cpfParceiro },
      { foneParceiro },
      { emailParceiro },
      { tipoChavePix },
      { chavePix },
    ],
  }

  //FIXME isso deve vir do BE
  // const host = 'http://18.211.149.146' // staging
  const host = 'https://srvc-nota-fiscal.lottustech.com.br' //   producao
  // const host = 'http://localhost:4360'
  const path = `${host}/api/v1/heternum/admin/command/public`
  return axios.post(path, params, { headers: getHeaders(oidEmpresa) })
}

export default {
  commandAtendimento,
  commandIndicador,
}
